import {
  AsyncMessageBundleManager,
  createAsyncMessageBundleManager,
  LocalizationContextBuilder,
} from '@amzn/arb-tools';
import { NodeEnv } from 'src/constants';

import arbManifest, {
  endpointMap,
} from '../../../build/translations/arbManifest';

const defaultLocale = 'en-US';

export const formatLocale = (locale: string): string => {
  locale = locale?.replace('_', '-');

  if (!Object.prototype.hasOwnProperty.call(endpointMap, locale)) {
    return defaultLocale;
  }

  return locale;
};

let manager: AsyncMessageBundleManager;

export const mbmInitializer = (locale: string) => {
  const localizationContextProvider = () =>
    new LocalizationContextBuilder()
      .withLocale(locale)
      .withDefaultLocale(defaultLocale)
      .build();

  return () => {
    if (!manager) {
      manager = createAsyncMessageBundleManager({
        arbManifest,
        localizationContextProvider,
        urlPrefix: 'translations',
        resolveBundleUrl: (url?: string) => {
          if (url) {
            return process.env.NODE_ENV === NodeEnv.development
              ? `/translations/${url}`
              : `https://d2ybzpzm1pr0am.cloudfront.net/translations/${url}`;
          }
          return undefined;
        },
      });
    }
    return manager;
  };
};
